// src/theme/createAppTheme.js
import { createTheme } from "@mui/material/styles";
import { createPalette } from "./createPalette";
import { createComponents } from "./createComponents";
import { tokens } from "./tokens";

export function createAppTheme(mode = "dark") {
  const palette = createPalette(mode);
  const t = mode === "dark" ? tokens.dark : tokens.light;

  // Base theme first
  let theme = createTheme({
    palette,
    shape: { borderRadius: 12 },
    typography: {
      fontFamily: [
        "Inter",
        "system-ui",
        "-apple-system",
        "Segoe UI",
        "Roboto",
        "Helvetica",
        "Arial",
        "sans-serif",
      ].join(","),
    },
  });

  // App-specific tokens (ONE namespace)
  theme.custom = {
    glass: {
      surface: t.glass.surface,
      border: t.glass.border,
      strongSurface: t.glass.strongSurface,
    },
    scrim: t.scrim,
    appBar: {
      mobileOverlay: "transparent",
    },
  };

  // Components override pass
  theme = createTheme(theme, {
    components: createComponents(theme),
  });

  return theme;
}
